<div>
  <app-navigation></app-navigation>
  <div class="content-panel">
    <router-outlet></router-outlet>
  </div>
</div>
<div class="icon-source-text">
  Icons made by
  <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a>
  from
  <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a>
</div>
